import { Dispatch } from 'redux';
import {
  ReportQueryGridPageByNode,
  ReportQueryInfoByNode,
} from '../../Interfaces/Reports/ReportQueryInfoByNode';
import {
  ReportQueryGridPageByStore,
  ReportQueryInfoByStore,
} from '../../Interfaces/Reports/ReportQueryInfoByStore';
import { actionCreators } from './ReportsState';
import { ReportExportRequestBody } from '../../Interfaces/Reports/ReportExportRequestBody';
import { ReportExportListRequest } from '../../Interfaces/Reports/ReportExportListRequest';

export const resetAssetsState = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.resetState());
};

export const fetchDivisions = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.fetchDivisions());
};

export const fetchStores = async (
  dispatch: Dispatch<any>,
  division: string,
) => {
  return dispatch(actionCreators.fetchStores(division));
};

export const fetchLanesBySite = async (
  dispatch: Dispatch<any>,
  siteNumber: string,
) => {
  return dispatch(actionCreators.fetchLanesBySite(siteNumber));
};

export const fetchCategories = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.fetchCategories());
};

export const fetchReportDataByNode = async (
  dispatch: Dispatch<any>,
  reportQueryInfo: ReportQueryInfoByNode,
) => {
  return dispatch(actionCreators.fetchReportDataByNode(reportQueryInfo));
};

export const fetchGridPageByNode = async (
  dispatch: Dispatch<any>,
  reportQueryInfo: ReportQueryGridPageByNode,
) => {
  return dispatch(actionCreators.fetchGridPageByNode(reportQueryInfo));
};

export const fetchReportDataByStore = async (
  dispatch: Dispatch<any>,
  reportQueryInfo: ReportQueryInfoByStore,
) => {
  return dispatch(actionCreators.fetchReportDataByStore(reportQueryInfo));
};

export const fetchGridPageByStore = async (
  dispatch: Dispatch<any>,
  reportQueryInfo: ReportQueryGridPageByStore,
) => {
  return dispatch(actionCreators.fetchGridPageByStore(reportQueryInfo));
};

export const setPanelBarVisibility = async (
  dispatch: any,
  showPanelBar: boolean,
) => {
  return dispatch(actionCreators.setPanelBarVisible(showPanelBar));
};

export const resetFetchError = async (dispatch: any) => {
  return dispatch(actionCreators.resetFetchError());
};

export const exportReportData = async (
  dispatch: Dispatch<any>,
  requestBody: ReportExportRequestBody,
) => {
  return dispatch(actionCreators.exportReportData(requestBody));
};

export const fetchReportExportStatusList = async (
  dispatch: Dispatch<any>,
  request: ReportExportListRequest,
) => {
  return dispatch(actionCreators.fetchReportExportStatusList(request));
};

export const fetchReportDownloadURL = async (
  dispatch: Dispatch<any>,
  filePath: string,
) => {
  return dispatch(actionCreators.fetchReportDownloadURL(filePath));
};

export const resetReportDownloadURL = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.resetReportDownloadURL());
};
